import { render, staticRenderFns } from "./OList.vue?vue&type=template&id=57c10684"
import script from "./OList.vue?vue&type=script&lang=js"
export * from "./OList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports